// import Route from "./components/Route";
// import ModalPage from "./views/ModalPage";
import LoginPage from "./views/LoginPage";
import AdminPage from "./views/AdminPage";
import PrivateRoute from "./components/PrivateRoute";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect,  } from "react";
import ResetPasswordPage from "./views/ResetPasswordPage";
//import Particles from 'react-particles-js';

// mx-auto
// function App() {
//   return (
//     <div className="container flex max-w-full">
//       {/* <Sidebar /> */}
//       <div className="flex justify-center mx-auto w-full">
//         <Route path="/">
//           <LoginPage />
//         </Route>
//         <Route path="/modal">
//           <ModalPage />
//         </Route>
//       </div>
//       <canvas
//         className="__background absolute -z-40 top-0 left-0 flex"
//         width="1024"
//         height="900"
//       ></canvas>
//     </div>
//   );
// }

function App() {

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('token'));  
    const now = new Date();
    if (token && token.expiresAt < now.getTime()) {
      localStorage.removeItem('token');
    };
  }, []);

  return (
    <BrowserRouter basename={'/lvlup-admin'}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/change-pass" element={<ResetPasswordPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AdminPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
